// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { isExist } from 'utils/helpers';

// Components
import TableHeader from 'components/Table/Header';
import Vendor from './Vendor';

import styles from './styles.styl';

const Table = ({
  className,
  sortType,
  sortTypes,
  onChangeSelect,
  onChangeCategory,
  query,
  onSearch,
  vendors,
  url,
}) => {
  return (
    <div className={cn(styles.Table, className)}>
      <TableHeader
        className={cn(styles.Table__row, styles.Table__header)}
        select={{
          name: 'sort_type',
          sortType,
          options: sortTypes,
          onChange: onChangeSelect,
        }}
        search={{
          name: 'search',
          placeholder: 'Search by name',
          query,
          onSearch,
        }}
      />

      {isExist(vendors, 'items') &&
        vendors.items.map(vendor => (
          <Vendor
            {...vendor}
            key={vendor.id}
            className={styles.Table__row}
            pageUrl={url}
            onChangeCategory={onChangeCategory}
          />
        ))}
    </div>
  );
};

Table.defaultProps = {
  className: '',
};

Table.propTypes = {
  className: PropTypes.string,
  vendors: PropTypes.object,
  sortType: PropTypes.string,
  sortTypes: PropTypes.array,
  onChangeSelect: PropTypes.func,
  query: PropTypes.string,
  onSearch: PropTypes.func,
  sort: PropTypes.func,
  url: PropTypes.string.isRequired,
  onChangeCategory: PropTypes.func,
};

export default Table;
